import React, { useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AOS from "aos";
import "aos/dist/aos.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./PetRegistration.css";
import { useNavigate, Link} from "react-router-dom";

const PetRegistration = () => {
  const navigate = useNavigate();

const cityData = [
  {
    city: "Delhi",
    docs: [
      "Vaccination Certificate",
      "Owner's ID Proof",
      "Pet's Photograph",
    ],
  },
  {
    city: "Mumbai",
    docs: [
      "Online Registration Portal",
      "Fee Payment",
      "Documents Required",
    ],
  },
  {
    city: "Bengaluru",
    docs: [
      "Online Registration",
      "Email Verification",
      "Registration Payment",
    ],
  },
  {
    city: "Chennai",
    docs: [
      "Vaccination Certificate",
      "Owner's ID Proof",
      "Pet's Photograph",
    ],
  },
];

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
  }, []);
  return (
    <>
     <section className="pet-registration-page">

      <div className="container py-5">

        {/* Heading */}
        <div className="text-center">
          <h1 className="page-title">Pet Registration</h1>
          <h2 className="page-subtitle">
            EVERYTHING PAWZIBLE IS HERE
          </h2>
        </div>

        {/* Why Register */}
        <div className="mt-5">
          <h3 className="section-title text-center">
            Why Register Your Pet?
          </h3>

          <div className="row justify-content-center text-center mt-4 g-4">

            <div className="col-lg-3 col-md-6">
              <div className="benefit-item">
                <img
                  src="/assets/imgs/pet_registration/legal.png"
                  alt=""
                />
                <span>Legal Ownership</span>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="benefit-item">
                <img
                  src="/assets/imgs/pet_registration/health.png"
                  alt=""
                />
                <span>Public Health & Safety</span>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="benefit-item">
                <img
                  src="/assets/imgs/pet_registration/access.png"
                  alt=""
                />
                <span>Access to Services</span>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="benefit-item">
                <img
                  src="/assets/imgs/pet_registration/travel.png"
                  alt=""
                />
                <span>Travel Compliance</span>
              </div>
            </div>

          </div>
        </div>

        {/* City Cards */}
        <div className="mt-5">
          <h3 className="section-title text-center">
           City-wise Registration Requirements
          </h3>

          <div className="row g-4 mt-2">

            {cityData.map((item, index) => (
              <div className="col-lg-3 col-md-6" key={index}>
                <div className="city-card h-100">

                  <div className="city-header">
                    {item.city}
                  </div>

                  <div className="city-body">
                   <div className="d-flex align-items-center header_s">
                     <p className="mb-0"><strong>Online Registration Required?</strong></p>
                    <p className="yes_div mb-0">Yes</p>
                   </div>

                    <p><strong>Required Documents</strong></p>

                    <ul>
                      {item.docs.map((doc, i) => (
                        <li key={i}>{doc}</li>
                      ))}
                    </ul>

                  </div>
                </div>
              </div>
            ))}

          </div>
        </div>

        {/* Process */}
        <div className="process-section mt-5">

          <h3 className="section-title text-center">
            General Registration Process
          </h3>

          <div className="process-content">

            <p>
              <strong>1. Gather Documents</strong>
            </p>

            <ul>
              <li>Vaccination Certificates .Owner's ID Proof .6 Pet Photograph</li>
            </ul>

            <p>
              <strong>2. Fill Application Form: </strong>
              Availability online or municipal offices.
            </p>

            <p>
              <strong>3. Submit Documents: </strong>
              Upload online or office.
            </p>

            <p>
              <strong>4. Pay Registration Fee: </strong>
              Fees vary by city.
            </p>

            <p>
              <strong>5. Receive License</strong>
            </p>

          </div>
        </div>

        {/* KCI Section */}
        <div className="kci-section mt-5">

          <h3 className="section-title text-center">
            Kennel Club of India (KCI) Registration
          </h3>

          <div className="row align-items-end">

            <div className="col-lg-3 text-center">
              <img
                src="/assets/imgs/pet_registration/cat.png"
                alt=""
                className="cat-image"
              />
            </div>

            <div className="col-lg-9">

              <h4 className="fw-bold">Purpose:</h4>

              <ul>
                <li>Pedigree certification and Dog Shows.</li>
              </ul>

              <h4 className="fw-bold mt-4">Process:</h4>

              <ul>
                <li>Fill Application Form.</li>
                <li>Submit Documents.</li>
                <li>Pay Registration Fee.</li>
                <li>Receive License.</li>
              </ul>

            </div>

          </div>
        </div>

      </div>

    </section>
    </>
  );
};

export default PetRegistration;
